import { useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'

import { EmailInput, FF2, IconName, Info } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Email = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const [itemToRemove, setItemToRemove] = useState<number | null>(null)

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index as 0}.emails`
  })

  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => itemToRemove !== null && remove(itemToRemove),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <Info label="22. E-mail address">
      {fields.map((field, index2) => (
        <Controller
          key={field.id}
          name={`subjectsInfo.${index as 0}.emails.${index2 as 0}.value`}
          render={({ field }) => (
            <FormRow>
              <Col>
                <FF2 field={field} input={(props) => <EmailInput {...props} />} />
              </Col>
              {fields.length > 1 && (
                <IconButton
                  face="negative"
                  icon={IconName.DELETE}
                  onClick={() => {
                    setItemToRemove(index2)
                    startDeleting()
                  }}
                />
              )}
            </FormRow>
          )}
        />
      ))}
      <Confirmation />
      <IconButton icon={IconName.ADD_GREEN} onClick={() => append({ value: '' })} />
    </Info>
  )
}
